<template>
  <div>
    <section class="ra-section newsletter dark">
      <div class="inner">
        <div class="grid">
          <div class="subject">Get updates</div>
          <div class="field">
            <input
              id="ra-email"
              type="email"
              placeholder="Your email address"
              name="email"
              :class="{ 'border-red': errors.has('email') }"
              v-model="email"
              v-validate="{
                required: true,
                email: true,
                newsletterCheckEmail: true,
              }"
            />
            <button
              id="ra-newsletter-button"
              type="button"
              v-on:click="emailSubmit"
            >
              <span v-if="!isLoading">Subscribe</span>
              <span v-if="isLoading">
                <i class="far fa-spinner-third fa-spin"></i>
              </span>
            </button>
          </div>
          <div class="spacer"></div>
          <div class="text">
            Subscribe to the WWF newsletter and stay up-to-date with the latest
            news on WWF’s work.
          </div>
        </div>
      </div>
    </section>

    <!-- NEWSLETTER MODAL -->
    <div class="modal" id="ra-modal" :class="{ visible: showModal }">
      <!-- STEP 1 -->
      <div class="frame" id="ra-modal-step1" :class="{ visible: isStepOne }">
        <div class="close ra-modal-close" v-on:click="closeModal">
          <i class="fa far fa-times"></i>
        </div>
        <h2>Get Updates</h2>
        <p>
          Confirm your registration for <br /><span id="ra-modal-email1"></span>
        </p>
        <div class="fields">
          <input type="text" placeholder="First name" name="firstName" />
          <input type="text" placeholder="Last name" name="lastName" />
          <input type="text" placeholder="Phone (optional)" name="phone" />
        </div>
        <button id="ra-modal-confirm" type="button" v-on:click="confirm">
          <span v-if="!isLoadingConfirm">Confirm</span>
          <span v-if="isLoadingConfirm">
            <i class="far fa-spinner-third fa-spin"></i>
          </span>
        </button>
      </div>

      <!-- STEP 2 -->
      <div class="frame" id="ra-modal-step2" :class="{ visible: !isStepOne }">
        <div class="close ra-modal-close" v-on:click="closeModal">
          <i class="fa far fa-times"></i>
        </div>
        <img
          src="https://www.wwf.org.au/images/UserUploadedImages/389/WWF_Logo_CMYK-01.svg"
          alt="WWF Logo"
        />
        <p>
          Your registration for <span id="aa-modal-email2">{{ email }}</span> is
          confirmed.
        </p>
        <button id="ra-modal-back" type="button" v-on:click="closeModal">
          Back to WWF
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import gtm from "./../../utils/gtm";

export default {
  name: "Newsletter",

  data: () => {
    return {
      email: null,
      firstName: null,
      lastName: null,
      phone: null,
      showModal: false,
      isStepOne: true,
      timeout: null,
      lastTimestamp: Date.now(),
      checkEmailLoading: false,
      emailRegex: /.+\@.+\..+/,
      isLoading: false,
      isLoadingConfirm: false,
    };
  },

  created() {
    const newsletterCheckEmail = (email) => {
      if (email.length > 0 && this.emailRegex.test(email)) {
        return new Promise((resolve, reject) => {
          let timestamp = Date.now(); // timestamp for this api call
          this.lastTimestamp = timestamp; // 1 , 2 , 3
          this.checkEmailLoading = true;
          // Fetch Suggestions
          this.$store
            .dispatch("validateEmail", email)
            .then((response) => {
              if (response && timestamp >= this.lastTimestamp) {
                this.checkEmailLoading = false;
                resolve(response);
              }
            })
            .catch((err) => {
              console.error(err);
              this.checkEmailLoading = false;
              // If the call failed, do not keep the user from donating
              resolve({
                valid: true,
              });
            });
        });
      } else {
        return {
          valid: false,
          data: { message: "Email invalid" },
        };
      }
    };

    Validator.extend("newsletterCheckEmail", {
      validate: newsletterCheckEmail,
      getMessage: (field, params, data) => data.message,
    });
  },
  methods: {
    emailSubmit() {
      this.isLoading = true;
      this.$validator.validate().then(async (result) => {
        if (result) {
          this.showModal = true;
        }

        this.isLoading = false;
      });
    },
    confirm() {
      this.isLoadingConfirm = true;
      this.$validator.validate().then(async (result) => {
        console.log("result", result);

        if (result) {
          const payload = {
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            postcode: this.postCode,
            programName: this.$config.NEWSLETTERSUBSCRIBELIST,
            cookieID: this.$cookie.get("_mkto_trk"),
            ssoId: this.$store.getters.ssoId,
          };

          console.log("Newsletter payload", payload);

          await this.$store.dispatch("saveLead", {
            campaignId: "newsletter-signup",
            lead: payload,
          });

          console.log("Newsletter submit success");

          // GTM Event Success
          gtm.formSubmitSuccessEvent("newsletter-signup");

          this.isStepOne = false;
        } else {
          // GTM Event Failure
          gtm.formSubmitEvent("newsletter-signup");
        }

        this.isLoadingConfirm = false;
      });
    },
    closeModal() {
      this.showModal = false;
      this.isStepOne = true;
      this.isLoading = false;
      this.isLoadingConfirm = false;

      // Reset form
      this.email = null;
      this.firstName = null;
      this.lastName = null;
      this.phone = null;
    },
  },
};
</script>

<style scoped>
button {
  height: 48px;
  padding: 0 calc(3 * var(--space));
  padding-bottom: calc(0.5 * var(--space));
  font-family: var(--font-secondary);
  font-size: 1.5em;
  text-transform: uppercase;
  color: #fff;
  background-color: var(--orange);
  border-radius: var(--border-radius);
  cursor: pointer;
}

input {
  margin-bottom: 0;
  height: 48px;
  font-size: 16px;
}

button:hover,
button:focus {
  background-color: var(--orange);
}

@media screen and (min-width: 1024px) {
  button {
    padding: 0 calc(1.5 * var(--space));
    padding-bottom: calc(0.25 * var(--space));
    font-size: 1.2em;
  }
}

/* NEWSLETTER */

section.newsletter {
  margin-bottom: calc(3 * var(--space));
}

section.newsletter .subject {
  display: none;
  grid-column: span 2;
  align-self: center;
  margin-top: calc(-0.3 * var(--space));
  font-family: var(--font-secondary);
  font-size: 2em;
  line-height: 100%;
  white-space: nowrap;
  text-transform: uppercase;
  color: #fff;
}

section.newsletter .field {
  grid-column: span 6;
  align-self: center;
  display: flex;
}

section.newsletter .field input {
  border: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

section.newsletter .field button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

section.newsletter .text {
  grid-column: span 4;
  display: flex;
  align-items: center;
  width: 100%;
  color: #fff;
  font-size: 1em;
}

@media screen and (max-width: 767px) {
  section.newsletter .grid {
    gap: calc(3 * var(--space));
    padding: calc(4 * var(--space)) calc(2 * var(--space));
  }

  section.newsletter .grid > div {
    grid-column: span 12;
    text-align: center;
  }

  section.newsletter .subject {
    display: block;
    font-size: 53px;
  }

  section.newsletter .field {
    flex-direction: column;
    gap: var(--space);
  }

  section.newsletter .text {
    justify-content: center;
  }
}

@media screen and (min-width: 1400px) {
  section.newsletter .subject {
    display: block;
  }

  section.newsletter .field {
    grid-column: span 4;
  }
}

/* NEWSLETTER MODAL */

.modal {
  z-index: 100;
  position: fixed;
  top: 0;
  right: 0;
  display: none;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal.visible {
  display: flex;
}

.modal .frame {
  position: relative;
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 580px;
  margin: var(--space);
  padding: calc(4 * var(--space));
  padding-top: calc(6 * var(--space));
  background-color: #fff;
}

.modal .frame#ra-modal-step2 {
  gap: calc(3 * var(--space));
}

.modal .frame.visible {
  display: flex;
}

.modal .frame .close {
  position: absolute;
  top: calc(3.5 * var(--space));
  right: calc(4 * var(--space));
  cursor: pointer;
}

.modal .frame img {
  width: 110px;
}

.modal .frame p {
  font-size: 16px;
  line-height: 140%;
  text-align: center;
}

.modal .frame p span {
  color: var(--orange);
}

.modal .frame .fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.modal .frame button {
  width: 100%;
}

@media screen and (min-width: 1024px) {
  .modal .frame {
    gap: var(--space);
  }

  .modal .frame p {
    font-size: 1.2em;
  }

  .modal .frame button {
    width: auto;
  }
}
</style>


// WEBPACK FOOTER //
// Newsletter.vue?44685b7a